import React from "react";
import ConfirmDialog from "../dialogs/confirmDialog";
import { Typography } from "@mui/material";
import { Document } from "modules/documents";
import { useSelector } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";

interface IPrivateFilesModalProps {
    enablePrivateFileModal: boolean;
    showPrivateFileModal: boolean;
    fileAttachmentDocumentsProperties: Document[];
    onClose: () => void;
    onDeny: () => void;
    onConfirm: () => void;
}

const PrivateFilesModal: React.FC<IPrivateFilesModalProps> = ({
    enablePrivateFileModal,
    showPrivateFileModal,
    fileAttachmentDocumentsProperties,
    onClose,
    onDeny,
    onConfirm
}) => {
    const tenantId = useSelector((state: GlobalApplicationState) => state.tenant.id);

    const getInvalidFilesErrorList = (): React.ReactElement => 
        <>
            <Typography>
                You are about to attach file(s) that currently have restricted access within your organization. Attaching these files to this email will grant access to all recipients, regardless of their existing permissions.
            </Typography>
            <ul
                style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                }}
            >
                {
                    fileAttachmentDocumentsProperties
                        .filter(d => d.audiences.length > 0)
                        .map(d => 
                            <li key={d.id}>
                                <a href={"/" + tenantId + `/admin/documents?previewDocumentId=${d.id}`} rel="noopener noreferrer" target="_blank">
                                    {d.fileName}
                                </a>
                            </li>
                        )
                }  
            </ul>
            <Typography>
                Would you like to proceed?
            </Typography>
        </>;

    return <ConfirmDialog
        title="Attaching Private File(s)"
        denyLabel="EDIT SELECTED FILES"
        confirmLabel="ATTACH"
        open={enablePrivateFileModal && showPrivateFileModal}
        onClose={onClose}
        onDeny={onDeny}
        onConfirm={onConfirm}
        headerStyle={{ paddingBottom: 0 }}
        
    >
        <div style={{ minWidth: 400 }}>
            {getInvalidFilesErrorList()}
        </div>
    </ConfirmDialog>;
};

export default PrivateFilesModal;
